import React, { useCallback, useEffect, useRef, useState } from "react";
import Layout from "../../Layout/Layout";
import "react-quill/dist/quill.snow.css";
import { useLocation } from "react-router-dom";
import articleService from "../../../apiService/article.service";
import { getPreviousDate } from "../../utils/dateFormate";
import {
    categoriesList,
} from "../../../apiService/category.service";
import { convertDateToFormat, validateDates } from "../../utils/utils";
import toast, { Toaster } from "react-hot-toast";
import FilterSection from "../../../base/FilterSection";
import DataTable from "../../../base/DataTable";
import Pagination from "../../../base/Pagination";

export const SignInMethodData = [
    ["Total", "Total Users"],
    ["google", 85974],
    ["mobile", 59727],
];

export const UserMethodData = [
    ["Total", "Total Users"],
    ["Casual", 85974],
    ["Loyal", 59727],
    ["Brand", 29720],
];

export const PieHoleOption = {
    pieHole: 0.56,
    is3D: false,
    legend: "none",
    chartArea: {
        left: 10,
        right: 10, // !!! works !!!
        bottom: 20, // !!! works !!!
        top: 20,
        width: "100%",
        height: "100%",
    },
};

const categoryTitle = [
    {
        id: '0',
        title: 'ID',
    },
    {
        id: '1',
        title: 'CATEGORY',
    },
    {
        id: '2',
        title: 'URL',
    },
    {
        id: '3',
        title: 'PV',
    },
    {
        id: '4',
        title: 'User',
    },
    {
        id: '5',
        title: 'New Users',
    },
    {
        id: '6',
        title: 'Returning Users'
    }
]

export default function Authors() {
    const [selectedDomain, setSelectedDomain] = useState([]);
    const [domainList, setDomainList] = useState([]);
    const { state } = useLocation();
    const [page, setPage] = useState(1);
    const [authorData, setAuthorData] = useState();
    const [isLoaded, setIsLoaded] = useState(false);
    const [dateValue, setDateValue] = useState({
        startDate: null,
        endDate: null,
    });
    const [onLastPage, setOnLastPage] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            run();
        }
    }, []);

    const getCategoriesList = useCallback(async () => {
        try {
            const response = await categoriesList(state?.domain, getPreviousDate(),
                            getPreviousDate(), {
                authorId: state?.authorId,
                isRegistered: state?.isRegistered
            }, state?.apiKey);
            const categoryList = response?.categoryList || [];
            
            const extendedCategoryList = [{ category: "All" }, ...categoryList];
            setDomainList(extendedCategoryList);
            let getCategoryIndex;
            if (state?.category) {
                getCategoryIndex = extendedCategoryList.find(
                    (category) => category.category === state?.category
                );
            }
            setSelectedDomain(getCategoryIndex?.category || "All");
        } catch (error) {
            console.log(error);
        }
    }, []);

    const handleChange = (e) => {
        const selectedCategory = domainList.find((list) => list.category === e.category);
        setSelectedDomain(selectedCategory?.category);
        setAuthorData([]);
        authorArticle(1, e.category);
    };    

    const authorArticle = useCallback(async (pageNo, cat) => {
        if (pageNo !== 0) {
            setPage(pageNo);
        }
        setIsLoaded(true);
        try {
            const response = await articleService(state?.domain, 10, page, {
                startDate: !dateValue.startDate
                    ? getPreviousDate()
                    : convertDateToFormat(dateValue.startDate),
                endDate: !dateValue.endDate
                    ? getPreviousDate()
                    : convertDateToFormat(dateValue.endDate),
                ...(cat !== 'All' && cat !== undefined && { category: cat }),
                authorId: state?.authorId,
                isRegistered: state?.isRegistered
            }, state?.apiKey);

            const articleCount = response.data.articleList.length;
            if (response.data?.articleList?.length) {
                setAuthorData((prev) => [...response.data?.articleList]);
                setOnLastPage(articleCount < 10);
                setHasMore(articleCount >= 10);
            }

            setIsLoaded(false);
        } catch (error) {
            console.error(error);
            setIsLoaded(false);
        }
    }, [page, state?.domain, state?.authorId, dateValue.startDate, dateValue.endDate, selectedDomain]);

    console.log("state?.authorId", state?.authorId);
    

    const run = async () => {
        getCategoriesList();
        authorArticle(page);
    };

    const onDateFilterApply = async () => {
        setAuthorData([]);
        await authorArticle(1);
    };

    const onNextPage = () => {
        
        if (!onLastPage && hasMore) {
            setAuthorData([]);
            authorArticle(page + 1);
        }
    };

    const onPreviousPage = () => {
        if(page === 1){
            return
        }
        setAuthorData([]);
        authorArticle(page - 1);
    }

    const onDateSelect = (date) => {
        let isValidDate;
        if (date.startDate !== null) {
            isValidDate = validateDates(convertDateToFormat(date.startDate))
        }

        if(isValidDate?.isValid === true) {
            setDateValue(date)
        } else if(isValidDate?.isValid === false) {
            return toast.error(isValidDate?.message)
        }
    }


    return (
        <Layout>
            <main>
                <Toaster/>
                <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
                    {/* <div className='flex justify-center mb-6'>
                        <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">
                            <a
                                href="/cdp/anonymous"
                                className="text-gray-50 hover:text-gray-50 group relative min-w-0 flex-1 overflow-hidden bg-red-500 hover:bg-red-600 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                            >
                                <span>Anonymous</span>
                                <span
                                    aria-hidden="true"
                                    className="bg-red-500 absolute inset-x-0 bottom-0 h-0.5"
                                />
                            </a>
                            <a
                                href="/cdp/anonymous/registered"
                                className="text-gray-500 hover:text-gray-500 group relative min-w-0 flex-1 overflow-hidden bg-gray-50 hover:bg-gray-100 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                            >
                                <span>Registered</span>
                                <span
                                    aria-hidden="true"
                                    className="absolute inset-x-0 bottom-0 h-0.5"
                                />
                            </a>
                        </nav>
                    </div> */}
                      <div className="text-gray-50 bg-white rounded-2xl shadow-lg">
                        <div className="mx-auto">

                            <FilterSection 
                                isAuthor
                                authorName={state?.author}
                                title={state?.category}
                                selectedDomain={selectedDomain}
                                domainList={domainList}
                                dateValue={dateValue}
                                handleChange={handleChange}
                                onDateSelect={onDateSelect}
                                onDateFilterApply={onDateFilterApply}
                            />
                            
                            <DataTable isAuthor categoryTitle={categoryTitle} categoriesData={authorData} isLoading={isLoaded} />
                            
                            <Pagination page={page} onNextPage={onNextPage} onPreviousPage={onPreviousPage} />
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    );
}
